module.exports = __webpack_public_path__ + "img/checkout-link.e271bb27.svg";